// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Cn = require("re-classnames/src/Cn.bs.js");
var Css = require("bs-css-dom/src/Css.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Belt_Array = require("bs-platform/lib/js/belt_Array.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Match$Blossom = require("re-blossom/src/Match.bs.js");
var VisuallyHidden = require("@reach/visually-hidden");
var Forms$BlossomPlayground = require("./Forms.bs.js");
var Graph$BlossomPlayground = require("./Graph.bs.js");
var Dialog$BlossomPlayground = require("./Dialog.bs.js");
var SampleData$BlossomPlayground = require("./SampleData.bs.js");

function setClosed(param) {
  return /* Closed */0;
}

function GraphTable$Dialog(Props) {
  var children = Props.children;
  var ariaLabel = Props.ariaLabel;
  var onDismiss = Props.onDismiss;
  return React.createElement(Dialog$BlossomPlayground.make, {
              onDismiss: onDismiss,
              className: "dialog__edit",
              ariaLabel: ariaLabel,
              children: null
            }, React.createElement("button", {
                  className: "dialog__close-button",
                  onClick: (function (param) {
                      return Curry._1(onDismiss, undefined);
                    })
                }, "Close"), children);
}

function GraphTable$Table(Props) {
  var vertices = Props.vertices;
  var editVertex = Props.editVertex;
  var editEdge = Props.editEdge;
  var mates = Props.mates;
  var graph = Props.graph;
  var disabledOpt = Props.disabled;
  var styleOpt = Props.style;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var style = styleOpt !== undefined ? Caml_option.valFromOption(styleOpt) : ({});
  var verticesIndices = vertices.length - 1 | 0;
  return React.createElement("table", {
              className: "graph-table",
              style: style
            }, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("th", {
                          className: "graph-table__corner font-small"
                        }, null), Belt_Array.map(Belt_Array.slice(Belt_Array.reverse(vertices), 0, verticesIndices), (function (p) {
                            return React.createElement("th", {
                                        key: Graph$BlossomPlayground.Vertex.toString(p),
                                        className: "graph-table__top-name",
                                        scope: "col"
                                      }, React.createElement("button", {
                                            className: "graph-table__name-button",
                                            disabled: disabled,
                                            onClick: (function (param) {
                                                return Curry._1(editVertex, p);
                                              })
                                          }, React.createElement("div", {
                                                className: "vertical-lr"
                                              }, Graph$BlossomPlayground.Vertex.toString(p))));
                          }))), Belt_Array.mapWithIndex(Belt_Array.slice(vertices, 0, verticesIndices), (function (index, i) {
                        return React.createElement("tr", {
                                    key: Graph$BlossomPlayground.Vertex.toString(i)
                                  }, React.createElement("th", {
                                        className: "graph-table__side-name",
                                        scope: "row"
                                      }, React.createElement("button", {
                                            className: "graph-table__name-button",
                                            disabled: disabled,
                                            onClick: (function (param) {
                                                return Curry._1(editVertex, i);
                                              })
                                          }, Graph$BlossomPlayground.Vertex.toString(i))), Belt_Array.mapWithIndex(Belt_Array.slice(Belt_Array.reverse(vertices), 0, verticesIndices), (function (index$prime, j) {
                                          if ((verticesIndices - index$prime | 0) <= index) {
                                            return React.createElement("td", {
                                                        key: Graph$BlossomPlayground.Vertex.toString(j),
                                                        className: "graph-table__null-cell"
                                                      });
                                          }
                                          var j$prime = Match$Blossom.get(mates, i);
                                          var mated = j$prime !== undefined && Graph$BlossomPlayground.Vertex.eq(j, Caml_option.valFromOption(j$prime)) ? true : false;
                                          var weight = Graph$BlossomPlayground.getEdge(graph, i, j);
                                          return React.createElement("td", {
                                                      key: Graph$BlossomPlayground.Vertex.toString(j),
                                                      className: Cn.$less$colon$great("graph-table__cell", Cn.on("graph-table__cell-mated", mated))
                                                    }, weight !== undefined ? React.createElement("button", {
                                                            className: "graph-table__button mated",
                                                            title: mated ? "Mated. " : "Not mated.",
                                                            disabled: disabled,
                                                            onClick: (function (param) {
                                                                return Curry._3(editEdge, i, j, weight);
                                                              })
                                                          }, React.createElement(VisuallyHidden.default, {
                                                                children: null
                                                              }, mated ? "Mated. " : "", "Set weight for " + i + " and " + j + "."), String(weight)) : React.createElement("button", {
                                                            className: "graph-table__button",
                                                            title: "Edge not set.",
                                                            disabled: disabled,
                                                            onClick: (function (param) {
                                                                return Curry._3(editEdge, i, j, undefined);
                                                              })
                                                          }, React.createElement(VisuallyHidden.default, {
                                                                children: null
                                                              }, mated ? "Mated. " : "", "Set weight for " + i + " and " + j + ".")));
                                        })));
                      }))));
}

var Table = {
  make: GraphTable$Table
};

function GraphTable(Props) {
  var vertices = Props.vertices;
  var graph = Props.graph;
  var dispatch = Props.dispatch;
  var cardinality = Props.cardinality;
  var setCardinality = Props.setCardinality;
  var mates = Props.mates;
  var styleOpt = Props.style;
  var style = styleOpt !== undefined ? Caml_option.valFromOption(styleOpt) : ({});
  var match = React.useState(function () {
        return /* Closed */0;
      });
  var setDialog = match[1];
  var dialog = match[0];
  var closeDialog = function (param) {
    return setDialog(setClosed);
  };
  var len = vertices.length;
  var tmp;
  if (len !== 1) {
    if (len !== 0) {
      var match$1 = Graph$BlossomPlayground.edgeCount(graph);
      tmp = React.createElement(React.Fragment, {
            children: null
          }, React.createElement(GraphTable$Table, {
                vertices: vertices,
                editVertex: (function (p) {
                    return setDialog(function (param) {
                                return {
                                        TAG: /* EditingVertex */0,
                                        _0: p
                                      };
                              });
                  }),
                editEdge: (function (i, j, w) {
                    return setDialog(function (param) {
                                return {
                                        TAG: /* EditingEdge */1,
                                        _0: i,
                                        _1: j,
                                        _2: w
                                      };
                              });
                  }),
                mates: mates,
                graph: graph
              }), match$1 !== 0 ? null : React.createElement("p", undefined, "Click a table cell to add an edge to the graph."));
    } else {
      tmp = React.createElement(React.Fragment, {
            children: null
          }, React.createElement("p", undefined, "No one to match. Add someone to begin."), React.createElement("p", undefined, React.createElement("button", {
                    onClick: (function (param) {
                        return dispatch({
                                    TAG: /* Set */5,
                                    _0: SampleData$BlossomPlayground.a
                                  });
                      })
                  }, "Load a sample graph")));
    }
  } else {
    var id = vertices[0];
    tmp = React.createElement("p", undefined, React.createElement("strong", undefined, Graph$BlossomPlayground.Vertex.toString(id)), " is alone. Add more people to start matching.");
  }
  var tmp$1;
  if (typeof dialog === "number") {
    switch (dialog) {
      case /* Closed */0 :
          tmp$1 = null;
          break;
      case /* NewVertex */1 :
          tmp$1 = React.createElement(GraphTable$Dialog, {
                children: React.createElement(Forms$BlossomPlayground.VertexAdder.make, {
                      dispatch: dispatch,
                      onSubmit: closeDialog,
                      names: Graph$BlossomPlayground.vertices(graph)
                    }),
                ariaLabel: "Adding a new person",
                onDismiss: closeDialog
              });
          break;
      case /* Reset */2 :
          tmp$1 = React.createElement(GraphTable$Dialog, {
                children: null,
                ariaLabel: "Reset graph options",
                onDismiss: closeDialog
              }, React.createElement("p", {
                    style: Css.style({
                          hd: Css.textAlign(/* center */98248149),
                          tl: /* [] */0
                        })
                  }, React.createElement("button", {
                        className: "dialog__button-delete",
                        onClick: (function (param) {
                            dispatch({
                                  TAG: /* Set */5,
                                  _0: SampleData$BlossomPlayground.a
                                });
                            return setDialog(setClosed);
                          })
                      }, "Reset to sample data")), React.createElement("p", {
                    style: Css.style({
                          hd: Css.textAlign(/* center */98248149),
                          tl: /* [] */0
                        })
                  }, React.createElement("button", {
                        className: "dialog__button-delete",
                        onClick: (function (param) {
                            dispatch({
                                  TAG: /* Set */5,
                                  _0: Graph$BlossomPlayground.empty
                                });
                            return setDialog(setClosed);
                          })
                      }, "Reset to blank data")));
          break;
      
    }
  } else if (dialog.TAG) {
    var j = dialog._1;
    var i = dialog._0;
    tmp$1 = React.createElement(GraphTable$Dialog, {
          children: React.createElement(Forms$BlossomPlayground.EdgeSetter.make, {
                dispatch: dispatch,
                onSubmit: closeDialog,
                i: i,
                j: j,
                w: dialog._2
              }),
          ariaLabel: "Editing edge between " + i + " and " + j,
          onDismiss: closeDialog
        });
  } else {
    var person = dialog._0;
    tmp$1 = React.createElement(GraphTable$Dialog, {
          children: React.createElement(Forms$BlossomPlayground.VertexEditor.make, {
                dispatch: dispatch,
                onSubmit: closeDialog,
                name: person,
                names: Graph$BlossomPlayground.vertices(graph)
              }),
          ariaLabel: "Editing person: " + Graph$BlossomPlayground.Vertex.toString(person),
          onDismiss: closeDialog
        });
  }
  return React.createElement("div", {
              className: "graph-table-wrapper",
              style: style
            }, React.createElement("div", {
                  className: "toolbar"
                }, React.createElement("button", {
                      className: "toolbar__item",
                      onClick: (function (param) {
                          return setDialog(function (param) {
                                      return /* Reset */2;
                                    });
                        })
                    }, "New graph"), React.createElement("button", {
                      className: "toolbar__item",
                      onClick: (function (param) {
                          return setDialog(function (param) {
                                      return /* NewVertex */1;
                                    });
                        })
                    }, "Add vertex"), React.createElement("label", undefined, "Maximum cardinality ", React.createElement("input", {
                          className: "toolbar__item",
                          checked: cardinality >= 3850884,
                          type: "checkbox",
                          onChange: (function (e) {
                              if (e.currentTarget.checked) {
                                return setCardinality(function (param) {
                                            return /* Max */3850884;
                                          });
                              } else {
                                return setCardinality(function (param) {
                                            return /* NotMax */-432534671;
                                          });
                              }
                            })
                        }))), tmp, tmp$1);
}

var make = GraphTable;

exports.Table = Table;
exports.make = make;
/* Css Not a pure module */
